import React from 'react';
import PropTypes from 'prop-types';

const LinkIcon = ()=>(
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9 17H7A5 5 0 0 1 7 7h2"/>
    <path d="M15 7h2a5 5 0 1 1 0 10h-2"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
  </svg>
);

export const ShareBtn = ({host,url,title,description,image,icon=<LinkIcon/>}) =>{
  const URI = "https://share.bassiani.com/?url="+host.concat(url)+"&title="+encodeURIComponent(title)+"&description="+encodeURIComponent(description)+"&image="+image;

  const copyToClipboard = str => {
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(str).catch(()=>{});
      return;
    }
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  const onShare = async ()=>{
    if(navigator.share){
      try{
        await navigator.share({title, text:description, url:URI});
        return;
      }catch (e){
        // user dismissed the sheet — fall through to copy
        if(e && e.name === "AbortError") return;
      }
    }
    copyToClipboard(URI);
  };

    return  <span className="share share-link-btn" onClick={onShare}>{icon}</span>
}
ShareBtn.propTypes={
  host:PropTypes.string.isRequired,
  url:PropTypes.string.isRequired,
  title:PropTypes.string.isRequired,
  description:PropTypes.string.isRequired,
  image:PropTypes.string.isRequired,
}
